// Sitemap.js
import React from 'react';
import '.././styles.css'

const Sitemap = () => {
  return (
    <div className="legal-links">
      <h1>Sitemap</h1>
      <ul>
        <li><a href="/">Home</a></li>
        <li><a href="/privacy-policy">Privacy Policy</a></li>
        <li><a href="/terms">Terms & Conditions</a></li>
        <li><a href="/sitemap">Sitemap</a></li>
        <li><a href="/disclaimer">Disclaimer</a></li>
        <li><a href="/contact">Contact Us</a></li>
        <li><a href="/about">About Us</a></li>
        <li><a href="/calculator/protein-intake-calculator">Protein Intake Calculator</a></li>
        <li><a href="/calculator/advanced-protein-calculator">Advanced Protein Intake Calculator</a></li>
        <li><a href="/calculator/calorie-calculator">Calorie Calculator</a></li>
        <li><a href="/calculator/body-fat-calculator">Body Fat Calculator</a></li>
        <li><a href="/calculator/bmi-calculator">BMI Calculator</a></li>
      </ul>
    </div>
  );
};

export default Sitemap;
